import type { FC, PropsWithChildren } from 'react';
import { memo, useEffect } from 'react';
import clsx from 'clsx';

import { useSizeStore } from 'store/size';

import { useFullSizeControls } from './hooks/useFullSizeControls';
import styles from './styles.module.scss';

const Wrapper: FC<PropsWithChildren> = ({ children }) => {
    const { isFull } = useSizeStore();

    const action = useFullSizeControls();

    useEffect(action, [isFull, action]);

    return (
        <div className={clsx(styles.wrapper, { 'app-is-full': isFull })} onClick={action} onMouseMove={action} onTouchStart={action}>
            {children}
        </div>
    );
};

export default memo(Wrapper);
